export default "__VITE_ASSET__DsLbb4yB__"